import React from "react";
import {HeroSection} from "../features/home/components/HeroSection";
import {HospitalitySection} from "../features/home/components/HospitalitySection";
import {ParallaxImageSection} from "../features/home/components/ParallaxImageSection";
import {TabbedStories} from "../components/common/TabbedStories";
import {TwoPaneSection} from "../components/TwoPaneSection";
import {InteractiveGridCarousel} from "../components/InteractiveGridCarousel";
import SectionDivider from "../components/common/SectionDivider";
import {VideoSection} from "../components/common/VideoSection";
import StoryCollection from "../utils/StoryCollection";

export const HomePage: React.FC = () => {
    const sportsStories: StoryCollection = {
        'Badminton': ['/images/badminton_1.webp'],
        'Pickleball': ['/images/pickleball_1.jpeg'],
        'Swimming Pool': ['/images/swimming_1.webp'],
    };

    const lifestyleStories: StoryCollection = {
        'Spa': ['/images/spa_1.webp'],
        'Gym': ['/images/gym_1.webp'],
        'Meditation ': ['/images/meditation.jpg'],
    };

    const juniorEngagementItems = [
        {
            title: 'INTERACTIVE GAMING ZONE',
            thumbnail: '/images/gaming_1.webp',
            images: ['/images/gaming_1.webp']
        },
        {
            title: 'DEDICATED KIDS PLAY AREA',
            thumbnail: '/images/kids_1.webp',
            images: ['/images/kids_1.webp']
        },
        {
            title: 'YOUTH SPORTS',
            thumbnail: '/images/youth_1.jpeg',
            images: ['/images/youth_1.jpeg']
        }
    ];

    const restaurantItems = [
        {
            title: 'MULTICUISINE RESTAURANT',
            thumbnail: '/images/restaurant_1.webp',
            images: ['/images/restaurant_1.webp']
        },
        {
            title: 'BAR',
            thumbnail: '/images/bar_1.webp',
            images: ['/images/bar_1.webp']
        },
        {
            title: 'CAFE',
            thumbnail: '/images/cafe_1.webp',
            images: ['/images/cafe_1.webp']
        }
    ];

    const happeningsStories: StoryCollection = {
        'New Year Celebrations': ['/images/new_year.webp'],
        'Holi Celebrations': ['/images/holi.webp'],
        'Diwali Celebrations': ['/images/diwali.webp'],
    };

    return (
        <div className="bg-dark-mode text-ivory">
            <HeroSection/>
            <VideoSection
                id="club-intro-video-section"
                nextSectionId="sports-section"
                videoSrc="/videos/intro.mp4"/>
            <ParallaxImageSection
                id="parallax-image-section"
                imageSrc="/images/about_banner.jpg"
            />
            <TabbedStories
                id="sports-section"
                title="SPORTS FACILITIES"
                stories={sportsStories}
                showTabs={false}
                cta={{title: 'More', href: '/sports-facilities'}}
            />
            <SectionDivider/>
            <TabbedStories
                id="lifestyle-section"
                title="LIFESTYLE & WELLNESS"
                stories={lifestyleStories}
                showTabs={false}
                cta={{title: 'More', href: '/lifestyle-and-wellness'}}
            />
            <SectionDivider/>
            <InteractiveGridCarousel
                id="junior-engagement-section"
                title="JUNIOR ENGAGEMENT"
                description="From arcade thrills to on field sports, All Aces Club offers a world of entertainment for our youngest members, designed to keep kids engaged, active, and social."
                items={juniorEngagementItems}
            />
            <SectionDivider/>
            <InteractiveGridCarousel
                id="culinary-pavilion-section"
                title="Restaurants & Bar"
                description="From sunrise coffee rituals to elegant evening cocktails, at All Aces Club our endeavor is to offer curated dining experiences. Our restaurants and bars would strive to serve global cuisines, handcrafted beverages, and an atmosphere designed for every occasion."
                items={restaurantItems}
            />
            <TwoPaneSection
                id="club-happenings-section"
                title="CLUB HAPPENINGS"
                main="/images/club_card.jpg"
                stories={happeningsStories}
            />
            <HospitalitySection/>
        </div>
    );
};